module.exports = __webpack_public_path__ + "static/media/latest_thumbnail.eb5e58c8.png";


//////////////////
// WEBPACK FOOTER
// ./src/latest_thumbnail.png
// module id = 241
// module chunks = 1